var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelfWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#bee5ee;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logitipo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.52,19.5l1.37-5.08A9.26,9.26,0,0,1,.71,9.88a9.41,9.41,0,1,1,4.92,8.25Zm5.37-3.27.32.19A7.67,7.67,0,1,0,3.6,13.83l.19.32L3,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.58,11.19a1.56,1.56,0,0,0-1.34-.3c-.35.14-.57.69-.8,1A.33.33,0,0,1,11,12a6.09,6.09,0,0,1-3-2.6.37.37,0,0,1,0-.51,2.06,2.06,0,0,0,.55-.9,1.91,1.91,0,0,0-.25-1.06A2.53,2.53,0,0,0,7.54,5.7a1.1,1.1,0,0,0-1.17.17,2.43,2.43,0,0,0-.82,1.88,2.89,2.89,0,0,0,.08.59A5,5,0,0,0,6.2,9.66a10.71,10.71,0,0,0,.59.9A9.26,9.26,0,0,0,9.38,13a7.69,7.69,0,0,0,1.61.77,3.64,3.64,0,0,0,1.87.29,2.23,2.23,0,0,0,1.7-1.26,1,1,0,0,0,.08-.65c-.1-.44-.7-.71-1.06-.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelfWhatsapp);
export default __webpack_public_path__ + "static/media/icon-telf-whatsapp.f8e0e9ff512d2e4b573978811b5ff18c.svg";
export { ForwardRef as ReactComponent };